import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { Icon } from '../Icon/Icon';
import { itemStyle, labelStyle, limitedLabelStyle, separatorStyle } from './Breadcrumb.css';

type Props = { limitWidth?: boolean } & ComponentPropsWithRef<'li'>;

export const BreadcrumbItem = ({ children, limitWidth = false, ...delegated }: Props) => {
  return (
    <li aria-current="page" {...delegated} className={clsx(itemStyle, delegated.className)}>
      <Icon className={separatorStyle} name="ChevronForward" />

      <span className={clsx(labelStyle, limitWidth && limitedLabelStyle)}>{children}</span>
    </li>
  );
};
